module.exports = __webpack_public_path__ + "img/img_sjgl_cjwt_n@2x.d9b795a3.png";